// react-magnetic-di - temporary comment, for auto dependency injection in tests
import { useEffect, useMemo, useRef } from 'react';
import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { fireOperationalEvent } from '@atlassian/ui-modifications-analytics';
import { useReadyPublicDataForOnInit } from '../../../../../../../controllers/issue-adjustments/hooks/use-ready-fields';
import { useViewType } from '../../../../../../../controllers/issue-adjustments/hooks/use-view-type';
import { useIssueAdjustmentsActions } from '../../../../../../../controllers/issue-adjustments/main';
import { getAnalytics } from '../../../../../../../controllers/view-configuration';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { filterFormDataBasedOnScopes } from '../utils/filter-based-on-scopes/form-data';
// eslint-disable-next-line @atlassian/tangerine/import/no-parent-imports
import { filterScreenTabsBasedOnReadScopes } from '../utils/filter-based-on-scopes/screen-tabs-data';
var successTabsInitialisation = function successTabsInitialisation(createAnalyticsEvent, viewType, screenTabsData) {
  if (screenTabsData.length) {
    fireOperationalEvent(createAnalyticsEvent, {
      action: 'success',
      actionSubject: 'jiraUiModifications.screenTabsInitialization',
      attributes: {
        initializedTabsCount: screenTabsData.length,
        viewType: viewType
      }
    });
  }
};
export var useOnInit = function useOnInit(_ref) {
  var moduleScopes = _ref.moduleScopes;
  var resolveOnInitPromise = useRef(null);
  var viewType = useViewType();
  var publicUIMDataForApp = useReadyPublicDataForOnInit({
    viewType: viewType
  });
  var _useAnalyticsEvents = useAnalyticsEvents(),
    createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
  var _useIssueAdjustmentsA = useIssueAdjustmentsActions(),
    successFieldsInitalisation = _useIssueAdjustmentsA.successFieldsInitalisation;
  var onInitPromise = useMemo(function () {
    var promise = new Promise(function (resolve) {
      resolveOnInitPromise.current = resolve;
    });
    promise.then(function () {
      // It cleans the resolveOnInitPromise to avoid calling the body
      // of the below useEffect after the onInit being resolved once.
      resolveOnInitPromise.current = null;
    });
    return promise;
  }, []);
  useEffect(function () {
    var handleChange = resolveOnInitPromise.current;
    if (publicUIMDataForApp === null || handleChange === null) {
      return;
    }
    var payload = {
      currentFormState: filterFormDataBasedOnScopes(publicUIMDataForApp.formData, viewType, moduleScopes),
      currentScreenTabsState: filterScreenTabsBasedOnReadScopes(moduleScopes, publicUIMDataForApp.screenTabsData)
    };
    handleChange(payload);
    successFieldsInitalisation({
      createAnalyticsEvent: createAnalyticsEvent
    });
    fireOperationalEvent(createAnalyticsEvent, {
      action: 'success',
      actionSubject: 'jiraUiModifications.appNotification',
      attributes: {
        lifecycleEvent: 'init',
        viewType: viewType
      }
    });
    successTabsInitialisation(createAnalyticsEvent, viewType, publicUIMDataForApp.screenTabsData);
    getAnalytics(viewType).markOnInitResolved();
  }, [successFieldsInitalisation, createAnalyticsEvent, publicUIMDataForApp, moduleScopes, viewType]);
  return {
    onInitPromise: onInitPromise
  };
};